export default {
    methods: {

        formatDate(date) {
            return this.$moment(date, this.$moment.defaultFormat).format("YYYY-MM-DD")
        },

        formatTo12HourTime(time) {
            return this.$moment(time, ["HH:mm:ss"]).format("hh:mm A")
        },

        formatTo24HourTime(time) {
            return this.$moment(time, ["hh:mm A"]).format("HH:mm:ss")
        }
    }
}
